import { getUrl } from '@buffer-mono/shared-utils/bibe'

import { channelServices } from '~publish/helpers/channels'
import type { Service } from '~publish/pages/Community/graphqlEnums'

/**
 * Minimal channel shape these nav helpers read. Kept structural (not the
 * codegen `Channel`) so channel objects from any query selection satisfy it —
 * this file is consumed outside Community via `useGetEngagementUrl`.
 */
type NavChannel = { name: string; service: string }

export function filterChannels<TChannel extends NavChannel>(
  channels: TChannel[],
  searchQuery: string | null | undefined,
): TChannel[] {
  if (!searchQuery || searchQuery.trim() === '') return channels

  return channels.filter(
    (channel) =>
      channel.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      channel.service.toLowerCase().includes(searchQuery.toLowerCase()),
  )
}

export const getChannelSuggestions = (
  channels: Pick<NavChannel, 'service'>[],
): Service[] | null => {
  if (channels.length > 3) return null

  const connectedChannelServices = new Set(
    channels.map((channel) => channel.service),
  )

  return channelServices.filter(
    (service) => !connectedChannelServices.has(service),
  )
}

export const getEngageUrl = (channelId?: string): string => {
  return channelId
    ? getUrl(`https://engage.buffer.com/${channelId}`)
    : getUrl('https://engage.buffer.com')
}

export const getCommunityUrl = (channelId: string): string => {
  return getUrl(`https://publish.buffer.com/comments/${channelId}`)
}

export const getCommunityByPostUrl = (
  channelId: string,
  postId?: string,
): string => {
  const path = postId
    ? `/comments/${channelId}/by-post/${postId}`
    : `/comments/${channelId}`

  return getUrl(`https://publish.buffer.com${path}`)
}

export function getTooltipContent(service: string, type: string): string {
  if (service === 'facebook' && type === 'group') {
    return 'Facebook Groups are not available for Community yet.'
  }

  if (service === 'instagram' && type === 'profile') {
    return 'Instagram Personal Profiles are not available for Community yet.'
  }

  return 'This channel is not available for Community yet.'
}
